export type StepId =
  | 'confirmBuilding'
  | 'aboutBuilding'
  | 'envelope'
  | 'basement'
  | 'windows'
  | 'doors'
  | 'energySources'
  | 'centralHeating'
  | 'heatPump'
  | 'boiler'
  | 'solar'
  | 'ventilation'
  | 'heating'
  | 'summary';

export interface StepDefinition {
  id: StepId;
  /** URL segment under the energy label route. */
  path: string;
  /** Top-level step number. Sub-steps carry their parent's id instead. */
  number?: number;
  parent?: StepId;
  /** Opened by an answer in an earlier step, see stepVisibility. */
  conditional?: boolean;
}

/** The flow in order, as laid out in the design document. */
export const STEPS: StepDefinition[] = [
  { id: 'confirmBuilding', path: 'bekreft-bygget', number: 1 },
  { id: 'aboutBuilding', path: 'om-bygget', number: 2 },
  { id: 'envelope', path: 'klimaskall', parent: 'aboutBuilding' },
  {
    id: 'windows',
    path: 'vinduer',
    parent: 'aboutBuilding',
    conditional: true,
  },
  {
    id: 'doors',
    path: 'dorer-og-porter',
    parent: 'aboutBuilding',
    conditional: true,
  },
  {
    id: 'basement',
    path: 'kjeller',
    parent: 'aboutBuilding',
    conditional: true,
  },
  { id: 'energySources', path: 'energikilder', number: 3 },
  {
    id: 'centralHeating',
    path: 'sentralvarme',
    parent: 'energySources',
    conditional: true,
  },
  {
    id: 'heatPump',
    path: 'varmepumpe',
    parent: 'energySources',
    conditional: true,
  },
  {
    id: 'boiler',
    path: 'forbrenningskjel',
    parent: 'energySources',
    conditional: true,
  },
  {
    id: 'solar',
    path: 'solceller',
    parent: 'energySources',
    conditional: true,
  },
  { id: 'ventilation', path: 'ventilasjon', number: 4 },
  { id: 'heating', path: 'oppvarming', number: 5 },
  { id: 'summary', path: 'oppsummering', number: 6 },
];

export const FIRST_STEP = STEPS[0];

/** the page shown once the form has been sent in, outside the steps */
export const SUBMITTED_PATH = 'sendt-inn';

export function getStep(id: StepId): StepDefinition {
  return STEPS.find((step) => step.id === id) as StepDefinition;
}

export function getStepIndex(id: StepId): number {
  return STEPS.findIndex((step) => step.id === id);
}

export function getPreviousStep(id: StepId): StepDefinition | undefined {
  const index = getStepIndex(id);
  return index > 0 ? STEPS[index - 1] : undefined;
}

export function getNextStep(id: StepId): StepDefinition | undefined {
  const index = getStepIndex(id);
  return index < STEPS.length - 1 ? STEPS[index + 1] : undefined;
}
